import { render, staticRenderFns } from "./AlternativeLabelsEditorPage.vue?vue&type=template&id=603a0e31&scoped=true"
import script from "./AlternativeLabelsEditorPage.vue?vue&type=script&lang=ts"
export * from "./AlternativeLabelsEditorPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603a0e31",
  null
  
)

export default component.exports